import { render, staticRenderFns } from "./EditFieldCourier.vue?vue&type=template&id=638ea960"
import script from "./EditFieldCourier.vue?vue&type=script&lang=js"
export * from "./EditFieldCourier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports